var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items",class:{
    reverse: _vm.isReversedLayout,
  }},[(!_vm.isMindAlte)?_c('div',{staticClass:"item",class:{ 'item--light': _vm.isBackColorBlack }},[_vm._t("item-back")],2):_vm._e(),_c('div',{staticClass:"item",class:[_vm.computedExtendClass, { 'item--light': _vm.isFrontColorBlack }]},[_vm._t("item-front")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }